<template>
    <div class="height1">
        <bread></bread>
        <!--    内容    -->
        <div class="center-content">
            <div class="iq-card-body">
                <div class="table-top">
                    <div class="iq-search-bar">
                        <el-form :model="searchForm" :inline="true">
                            <el-form-item>
                                <el-date-picker v-model="searchForm.datepicker" type="daterange" range-separator="至"
                                    start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"
                                    :picker-options="pickerOptions0" size="small" style="margin-right: 10px" @change="search">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item>
                                <el-input v-model="searchForm.keyWord" type="text" size="small" placeholder="订单编号"
                                    @keyup.enter.native="search" clearable ></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" size="small" @click="search()">搜索</el-button>
                            </el-form-item>
                            <el-form-item>
                                <download-excel v-if="tableData.length>0" :data="tableData" 
                                    :fields="json_fields" worksheet="My Worksheet" :header="title"
                                    :name="`${title}.xls`" class="excel">
                                    <el-button type="warning" size="mini" class="el-icon-download">导出当前页数据</el-button>
                                </download-excel>
                            </el-form-item>
                            <el-form-item>
                                <download-excel v-if="DataCount" :fields="json_fields" :fetch="fetchData"
                                    worksheet="My Worksheet" :header="title" :name="`${title}_All.xls`" class="excel">
                                    <el-button type="danger" size="mini" class="el-icon-download">导出{{DataCount}}条数据</el-button>
                                </download-excel>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
                <el-table :data="tableData" stripe style="width: 100%" height="calc(100% - 90px)" :header-cell-style="{background:'#F5F7FC'}">
                    <el-table-column prop="orderNum" label="订单编号">
                    </el-table-column>
                    <el-table-column prop="userName" label="购买会员">
                    </el-table-column>
                    <el-table-column prop="video.name" label="视频标题" width="250px">
                    </el-table-column>
                    <el-table-column prop="money" label="支付金额（元）">
                    </el-table-column>
                    <el-table-column prop="paySuccessTime" label="支付时间">
                        <template slot-scope="scope"> {{ scope.row.paySuccessTime | timefilters }} </template>
                    </el-table-column>
                </el-table>
                <el-pagination @current-change="ChangePage" :page-size="PageSize" :current-page="PageIndex"
                    :total="DataTotal" layout="total, prev, pager, next, jumper"></el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import { STATS } from "../../../../components/HospitalDomain/STATS"
import bread from "../../../../components/common/breadcrumb";

export default {
    name: "OwnSales",
    components: {
        bread
    },
    data() {
        var statistics = new STATS(this.TokenClient, this.Services.Healthy)
        return {
            StatisticsDomain: statistics,
            tableData: [],
            searchForm: {
                statrTime: '',
                endTime: '',
                keyWord: '',
                datepicker: ''
            },
            PageIndex: 1,
            PageTotal: 1,
            PageSize: 15,
            DataTotal: 0,
            pickerOptions0: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                }
            },
            title: '视频销售统计',
            DataCount:0,
            json_fields: {
                "订单编号": 'orderNum',
                "购买会员": 'userName',
                "视频标题":  {
                    callback: (val) => {
                        return `${val.video.name}`
                    }
                },
                "支付金额": 'money',
                "下单时间": {
                    filed: 'paySuccessTime',
                    callback: (val) => {
                        var val = val.paySuccessTime
                        return this.$fliters.timefilters(val)
                    }
                },
            },
        }
    },
    mounted() {
        this.PageIndex = 1;
        this.getList();
    },
    methods: {
        search() {
            this.PageIndex = 1;
            this.getList();
        },
        ChangePage(pageIndex) {
            this.PageIndex = pageIndex;
            this.getList();
        },
        async fetchData() {
            var _this = this;
            return await _this.getAllData()
        },
        getAllData() {
            var _this = this;
            return new Promise((resolve, reject) => {
                var item = _this.searchForm;
            if (_this.searchForm.datepicker) {
                item.startTime = _this.searchForm.datepicker[0] + ' 00:00:00';
                item.endTime = _this.searchForm.datepicker[1] + ' 23:59:59';
            } else {
                item.startTime = "";
                item.endTime = "";
            }
            _this.StatisticsDomain.VideoSales(item.startTime, item.endTime, item.keyWord, 1, _this.DataCount,
                    function (data) {
                        resolve(data.data.results);
                    },
                    function (err) {
                        resolve('');
                        console.log(err);
                    });
            })

        },
        getList() {
            var _this = this;
            _this.tableData = [];
            var item = _this.searchForm;
            if (_this.searchForm.datepicker) {
                item.startTime = _this.searchForm.datepicker[0] + ' 00:00:00';
                item.endTime = _this.searchForm.datepicker[1] + ' 23:59:59';
            } else {
                item.startTime = "";
                item.endTime = "";
            }
            _this.StatisticsDomain.VideoSales(item.startTime, item.endTime, item.keyWord, _this.PageIndex,null,
                function (data) {
                    _this.tableData = data.data.results?data.data.results:[];
                    _this.PageIndex = data.data.pageIndex;
                    _this.PageSize = data.data.pageSize;
                    _this.PageTotal = data.data.pageCount;
                    _this.DataTotal = data.data.dataTotal;
                        _this.DataCount = data.data.dataTotal;
                },
                function (error) {
                    console.log(error);
                });
        }
    }
}
</script>

<style scoped>
/*content*/

</style>
